// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__h93Rs","title":"ClientCherryInfo_title__1SPNg","itemText":"ClientCherryInfo_itemText__1h6xU"};